export function handleRefHeightChange(node, setHeight) {
  if (node !== null && node !== void 0 && node.clientHeight) {
    setHeight(node.clientHeight);
  }
}